import { io } from 'socket.io-client';
//export const socket = io('http://localhost:5031', {
export const socket = io('https://apisolicitacao.siffrutasfuturo.com.br', {
  transports: ['websocket'],
});
